export default "__VITE_ASSET__f3035f1b__"